import { createGlobalStyle } from "styled-components";

import { fonts, transition, baseColors } from "./variables";

const BaseStyle = createGlobalStyle`
  *, &:before, &:after {
    box-sizing: border-box;
  }
  html,
  body {
    font-family: ${fonts.fontBauRegular};
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    font-family: ${fonts.fontInterstateUltraBlack};
    margin-top: 0;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  button,
  a {
    transition: ${transition.baseTransition};
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: ${baseColors.baseLinkColor};
    &:hover,
    &:focus {
      color: ${baseColors.baseLinkHoverColor};
      text-decoration: none;
    }
  }

  button {
    border: none;
    background-color: transparent;
    &:hover, &:focus {
      outline: none !important;
    }
  }

  p, ul {
    margin-top: 0;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ul.af_list {
    max-width: 360px;
  }
  /* AddressFinder */
`;

export default BaseStyle;
